import { getContext } from '@fiverr-private/fiverr_context';
import { PAGE_NAME } from '../../constants/recommendations';

export const buildSourceInfo = ({ componentName }: { componentName: string }) => {
    const { userGuid, pageCtxId } = getContext();

    return {
        name: PAGE_NAME,
        component: {
            name: componentName,
        },
        user: {},
        page: {
            ctxId: pageCtxId,
        },
        userGuid,
    };
};
